export const DRAFT = 1;
export const COMPLETED = 2;
